export default __webpack_public_path__ + "static/media/rabi2jpg.ed72e4d5.jpg";